import MainContext from 'context/MainContext';
import { useContext, useEffect } from 'react';

function useModalCalendarForm(params) {
    const {
        selectedCalendar,
        calendarFormOnSubmit,
        createNewCalendar,
        calendarParentId,
        calendarParentType,
        modalCalendarFormOpen,
        modalCalendarType,
        setModalCalendarFormOpen,
        setModalCalendarType,
        setSelectedCalendar,

        setCreateNewCalendar,
        setCalendarParentId,
        setCalendarParentType,
        setCalendarFormOnSubmit,
    } = useContext(MainContext)

    useEffect(() => {
        if (params?.onSubmit) {
            setCalendarFormOnSubmit(params.onSubmit)
        }
    }, [params?.onSubmit, setCalendarFormOnSubmit])

    const closeCalendarForm = () => {
        setModalCalendarType(null)
        _setSelectedCalendar(null)
        _setCalendarFormOnSubmit()
        // setSelectedCalendarId(null)
        setModalCalendarFormOpen(false)
        setCreateNewCalendar(false)
        setCalendarParentId()
        setCalendarParentType()
    }

    const openCalendarForm = (newCalendarType, calendarId = null) => {
        setModalCalendarType(newCalendarType)
        _setSelectedCalendar(calendarId)
        setModalCalendarFormOpen(true)
    }

    const openCreateNewCalendarForm = (newCalendarType) => {
        setModalCalendarType(newCalendarType)
        _setSelectedCalendar(null)
        setModalCalendarFormOpen(true)
        setCreateNewCalendar(true)
    }

    const _setCalendarParentId = (value) => {
        setCalendarParentId(value)
    }
    const _setCalendarParentType = (value) => {
        setCalendarParentType(value)
    }
    const _setSelectedCalendar = (value) => {
        setSelectedCalendar(value)
    }
    const _setCalendarFormOnSubmit = (value) => {
        setCalendarFormOnSubmit(value)
    }

    return {
        calendarType: modalCalendarType,
        modalIsOpen: modalCalendarFormOpen,
        // selectedCalendarId: selectedCalendarId,
        createNewCalendar: createNewCalendar,
        calendarParentId: calendarParentId,
        calendarParentType: calendarParentType,
        selectedCalendar,
        calendarFormOnSubmit,

        closeCalendarForm: () => closeCalendarForm(),
        openCalendarForm: (value, calendarId) => openCalendarForm(value, calendarId),
        openCreateNewCalendarForm: (value) => openCreateNewCalendarForm(value),
        _setCalendarParentId: (value) => _setCalendarParentId(value),
        _setCalendarParentType: (value) => _setCalendarParentType(value),
        _setSelectedCalendar: (value) => _setSelectedCalendar(value),
        _setCalendarFormOnSubmit: (value) => _setCalendarFormOnSubmit(() => value),
    };
}

export default useModalCalendarForm